import styled from 'styled-components';

export const Subtitle = styled.div`
  font-size: 11px;

  img {
    margin-right: 2px;
  }
`;

export const SubtitlesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
`;

export const MapSubtitlesWrapper = styled.div`
  position: absolute;
  bottom: 23px;
  right: 60px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 8px;
  border-radius: 3px;
  width: 200px;
  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.21);

  p {
    color: rgba(0,0,0,0.6);
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
  }
`;
